




import { Vue, Component, Prop } from 'vue-property-decorator';

import { formatPhone } from '@/utils/phone';

@Component({})
export default class PhoneDisplay extends Vue {
    @Prop({ required: true }) phone!: string

    get formattedPhone() {
        return formatPhone(this.phone);
    }
}
